import EditCampaignPage from './EditCampaignPage';

export default EditCampaignPage;
